exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-item[data-v-5305bb7c]{margin:auto;overflow-y:auto;overflow-x:hidden;height:calc(100vh - 80px)}#mainpanel[data-v-5305bb7c]{height:100%}#mainpanel.minimize[data-v-5305bb7c]{transition:width .4s ease}#mainpanel.expanded[data-v-5305bb7c]{width:100%;transition:width .4s ease}@media (max-width:768px){#mainpanel[data-v-5305bb7c]{height:100vh}.panel-item[data-v-5305bb7c]{height:calc(100vh - 10px)}#mainpanel.expanded[data-v-5305bb7c],#mainpanel.minimize[data-v-5305bb7c]{transition:none;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5305bb7c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/containers/panels.vue
// module id = 1507
// module chunks = 0